import { render, staticRenderFns } from "./FullscreenLayout.vue?vue&type=template&id=754b767b"
import script from "./FullscreenLayout.vue?vue&type=script&lang=js"
export * from "./FullscreenLayout.vue?vue&type=script&lang=js"
import style0 from "./FullscreenLayout.vue?vue&type=style&index=0&id=754b767b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports